import React from "react";
import { useHistory } from "react-router-dom";
import LangSelect from "../multiLang/multiLang";
import { useTranslation } from "react-i18next";

const VoucherHeader = () => {
  const history = useHistory();

  const { t } = useTranslation("header");
  const { t: isLang } = useTranslation("type");

  return (
    <>
      <header className="voucher-header voucher">
        <div className="header-inner voucher">
          <a href="https://www.mss.go.kr/" target="_blank">
            <img
              className="voucher-logo voucher"
              src="./assets/logo/logo_mss.png"
              alt="Ministry of SMEs and Startups"
            />
          </a>
          <ion-icon class="icon-close" name="close-outline"></ion-icon>
          <a href="https://www.readyplay.co.kr/" target="_blank">
            <img
              className="voucher-logo voucher"
              src="./assets/logo/logo_bk.png"
              alt="Ready Play"
            />
          </a>
        </div>
        <div style={{ display: "none" }}>
          <div className="nav__menu">
            <div className="hamburger" />
          </div>
          <nav className="nav">
            <LangSelect />
          </nav>
        </div>
      </header>
    </>
  );
};

export default VoucherHeader;
